var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"prdList clearfix"},[_c('a',{attrs:{"href":_vm.prdUrl}},[_c('img',{attrs:{"src":_vm._f("urlProtocol")(_vm.imgUrl),"alt":""}}),_vm._v(" "),_c('div',{staticClass:"intro"},[_c('h3',[_vm._v(_vm._s(_vm.name))]),_vm._v(" "),(_vm.sell)?_c('p',{staticClass:"price sale-price"},[_vm._v("¥"+_vm._s(_vm.sell))]):_vm._e()])])])}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-cf4d32ee","hasScoped":true,"transformToRequire":{"video":["src","poster"],"source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/commons/productList.vue
// module id = null
// module chunks = 